import React from 'react';
import { Typography } from '@mui/material';
import PageContainer from '../../components/layout/PageContainer';
import PageField from '../../components/layout/PageField';
import ContactForm from '../../components/ContactForm/ContactForm';

const ContactUs = () => {
  return (
    <>
      <PageField>
        <PageContainer>
          <Typography variant="overline" color="primary" sx={{ fontWeight: 700, letterSpacing: '0.08em' }}>
            Contact
          </Typography>
          <Typography variant="h1" sx={{ fontSize: { xs: '2.4rem', md: '3.25rem' }, maxWidth: 760, mt: 1, mb: 2 }}>
            Tell us about the work
          </Typography>
          <Typography color="text.secondary" sx={{ maxWidth: 680, fontSize: '1.125rem', lineHeight: 1.6 }}>
            Describe the system and what needs to change. The form is the way to reach us.
          </Typography>
        </PageContainer>
      </PageField>
      <PageContainer>
        <ContactForm embedded />
      </PageContainer>
    </>
  );
};

export default ContactUs;
